import { Route } from 'vue-router';

export const getRedirectUrl = (route: Route) => {
  let redirect_url = route.query.redirect;
  if (redirect_url) {
    for (const [key, value] of Object.entries(route.query)) {
      if (key !== 'redirect') {
        redirect_url = redirect_url + `&${key}=${value}`;
      }
    }
    if (window.location.hash) {
      redirect_url = redirect_url + window.location.hash;
    }
    return redirect_url;
  } else {
    return null;
  }
};

export const isSamlLogin = (route: Route) => {
  const query = route.query;
  return query && query.type && query.type === 'saml';
};
